import { render, staticRenderFns } from "./UidInputComponent.vue?vue&type=template&id=0497c953"
import script from "./UidInputComponent.vue?vue&type=script&lang=js"
export * from "./UidInputComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports